import InternalCheckbox from './Checkbox';
import Group from './Group';
var Checkbox = InternalCheckbox;
Checkbox.Group = Group;
Checkbox.__ANT_CHECKBOX = true;
export default Checkbox;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/checkbox/index.js
// module id = 78
// module chunks = 0